<template lang="pug">
.student-center-base-container
  .header
    .title
      img.icon(
        src="https://m.hellobike.com/resource/AppPlatformH5/base-success/KuL_MBorQPxdLk77Byvxe.svg"
      )
      span.text 学生特权
      span.school(v-if="info && info.college") {{ info.college }}
    img.ha(
      src="https://m.hellobike.com/resource/AppPlatformH5/base-success/V-gSooX6Z_NgX9BFr4ir4.png"
    )
  .modules
    template(v-for="m in modules")
      template(v-if="STUDENT_MODULE_COMPONENT[m]")
        component.student-module(
          :is="STUDENT_MODULE_COMPONENT[m]",
          :class="[m]"
        )(
          ref="module",
          :activity="activity"
        )
  BizIntro.biz-intro-outside(v-if="!env.isEasyBikeApp")
  .rule.flex-mid(@click="goRule")
    span 活动规则
    .common-arrow-right
</template>

<script>
import { getCommonConfig } from '@/api/card';
import { getPageModule } from '@/api/common';
import { env } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getTokenAndKey, isPreRender } from '../../utils';
import Cards from './components/cards';
import { STUDENT_MODULE, STUDENT_MODULE_COMPONENT } from './consts';
import { getStudentAuthInfo, getPort } from './utils';
import BizIntro from './components/biz-intro.vue';

const LOCAL_MODULES = [STUDENT_MODULE.CARD, STUDENT_MODULE.COUPON];

export default {
  components: {
    Cards,
    BizIntro,
  },
  data() {
    return {
      STUDENT_MODULE_COMPONENT,
      modules: [...LOCAL_MODULES],
      modal: false,
      info: null,
      activity: null,
      modalActivity: null,
      env,
    };
  },
  created() {
    UBT.pageView({
      pageId: 'APP_student_ok',
      categoryId: 'platform',
      businessInfo: {
        adsource: this.$route.query.adsource,
        port: getPort(),
      },
    });
  },
  mounted() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }
    this.getData();
  },
  methods: {
    async getData() {
      getStudentAuthInfo().then((info) => {
        this.info = info;
      });
      const { token } = await getTokenAndKey();
      const { student } = await getCommonConfig({ token })
        .then((v) => v.data)
        .catch(() => ({}));
      if (student) {
        const { coupon, modal } = student;
        this.activity = coupon || null;
        this.modalActivity = modal || {};
      }
      await getPageModule({
        token,
        pageType: 17,
      })
        .then((v) => {
          // const modules = [...LOCAL_MODULES];
          if (v && v.data && v.data.moduleList) {
            this.modules = v.data.moduleList.map((m) => m.moduleKey);
          }
        })
        .catch(() => {});
      this.$nextTick(() => {
        (this.$refs.module || []).forEach((m) => {
          if (m && typeof m.start === 'function') {
            m.start();
          }
        });
      });
    },
    goRule() {
      window.location.href = 'http://h.c3x.me/11dFcv';
    },
  },
};
</script>

<style lang="less" scoped>
.student-center-base-container {
  min-height: 100%;
  background: #f0f3f5;
  padding-bottom: 0.2rem;

  .rule {
    font-size: 0.12rem;
    color: #879099;
    margin-top: 0.2rem;

    .common-arrow-right {
      border-color: #879099;
    }
  }

  .biz-intro-outside {
    margin: 0 0.12rem 0;
  }

  .header {
    width: 100%;
    height: 2.37rem;
    background-image: url(https://m.hellobike.com/resource/AppPlatformH5/base-success/UOWACLlS2Z3Q0IjK2x0Cx.png);
    background-size: 100% 100%;
    position: relative;

    .ha {
      position: absolute;
      right: 0;
      top: 0.26rem;
      z-index: 10;
      // width: 1.65rem;
      height: 1.55rem;
    }

    .title {
      position: absolute;
      display: flex;
      align-items: center;
      top: 0.22rem;
      left: 0.25rem;

      .text {
        font-size: 0.14rem;
        font-weight: 600;
        color: #fff;
      }

      .school {
        height: 0.14rem;
        font-size: 0.1rem;
        color: #fff;
        line-height: 0.14rem;
        margin-left: 0.09rem;
      }
    }
  }

  .modules {
    width: 100%;
    margin-top: -0.8rem;
    padding: 0 0.12rem;
    position: relative;
    z-index: 8;
  }

  .student-module {
    background: #fff;
    box-shadow: 0 0.01rem 0.05rem 0 rgba(0, 0, 0, 0.06);
    border-radius: 0.14rem;
    padding: 0.16rem 0.12rem;

    &:not(:first-of-type) {
      margin-top: 0.12rem;
    }
  }
}
</style>
